module.exports = __webpack_public_path__ + "static/media/profileIcon.1f1e4966.png";